import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class MenuService {

	constructor(private http: HttpClient) { }

	getMenuList(): Observable<any> {
		return this.http.get(environment.BASE_URL_AUTHENTICATE + 'menu');
	}
}
